/* eslint-disable max-len */
import GEN from '../../../../assets/generalDisclosure.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  CSRDetailsTabQuestions,
  detailsOfTheListedEntityTabQuestions,
  employeesTabQuestions,
  holdingSubsidiaryAndAssociateCompaniesTabQuestions,
  operationsTabQuestions,
  productsServicesTabQuestions,
  transparencyAndDisclosuresCompliancesTabQuestions
} from './generalDisclosureTabs';

export const generalDisclosure = {
  header: {
    imageUrl: GEN,
    title: 'SECTION A: GENERAL DISCLOSURES',
    description: `Focuses on governance-related aspects, encompassing corporate structure, ethics, 
      board composition, and policies shaping sustainable practices and accountability.`,
    noOfModules: 34,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.BRSR.generalDisclosure,
  tabs: [
    {
      id: 'detailsOfTheListedEntity',
      title: 'Details of the listed entity',
      questions: detailsOfTheListedEntityTabQuestions,
      accordion: false
    },
    {
      id: 'productsServices',
      title: 'Products / Services',
      questions: productsServicesTabQuestions,
      accordion: true
    },
    {
      id: 'operations',
      title: 'Operations',
      questions: operationsTabQuestions,
      accordion: true
    },
    {
      id: 'employees',
      title: 'Employees',
      questions: employeesTabQuestions,
      accordion: true
    },
    {
      id: 'holdingSubsidiaryAndAssociateCompanies',
      title:
        'Holding, Subsidiary and Associate Companies (including joint ventures)',
      questions: holdingSubsidiaryAndAssociateCompaniesTabQuestions,
      accordion: true
    },
    {
      id: 'CSRDetails',
      title: 'CSR Details',
      questions: CSRDetailsTabQuestions,
      accordion: false
    },
    {
      id: 'transparencyAndDisclosuresCompliances',
      title: 'Transparency and Disclosures Compliances',
      questions: transparencyAndDisclosuresCompliancesTabQuestions,
      accordion: true
    }
  ]
};
